import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { UxModule } from '@app/shared/ux/ux.module';
import {
    InsuranceEndProductComponent,
    InsuranceEndProductFormComponent,
    InsuranceEndProductVehicleFormComponent
} from '../insurance-end-product';
import { CancelInsuranceListProductComponent } from './cancel-insurance-list-product/cancel-insurance-list-product.component';
import { CancelInsuranceListComponent } from './cancel-insurance-list.component';
import { CynoFormModule } from '@app/shared/cyno-form/cyno-form.module';
import { WucBalloonModule, WucIconModule } from '@inshared/website-ui-components';

@NgModule({
    imports: [CommonModule, UxModule, PipesModule, InsuranceEndProductComponent, InsuranceEndProductFormComponent, InsuranceEndProductVehicleFormComponent, CynoFormModule, WucBalloonModule, WucIconModule],
    exports: [CancelInsuranceListComponent],
    declarations: [CancelInsuranceListComponent, CancelInsuranceListProductComponent],
})
export class CancelInsuranceListModule { }
